export default {"src":"/_next/static/media/ribbon.bf47f056.svg","height":403,"width":1440,"blurWidth":0,"blurHeight":0};